import { format, toZonedTime } from 'date-fns-tz';

export default function showExactDate(date: string) {
    return format(toZonedTime(date, 'UTC'), 'dd/MM/yyyy');
}